export const removeInsignificantZero = (number) => {
  const result = number?.toString();

  return result?.toString();
};
